(function () {
  class EuroguardSmarterChoiceComparison {
    constructor(root) {
      this.root = root;
      this.buttons = Array.from(root.querySelectorAll('[data-eg-smarter-choice-tab-button]'));
      this.panels = Array.from(root.querySelectorAll('[data-eg-smarter-choice-panel]'));

      this.bindTabs();

      const activeButton = this.buttons.find((button) => button.classList.contains('is-active')) || this.buttons[0];
      if (activeButton) {
        this.setActiveTab(activeButton.dataset.egSmarterChoiceTab);
      }
    }

    bindTabs() {
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.setActiveTab(button.dataset.egSmarterChoiceTab);
        });
      });
    }

    setActiveTab(tab) {
      if (!tab) return;

      this.buttons.forEach((button) => {
        const isActive = button.dataset.egSmarterChoiceTab === tab;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.egSmarterChoiceTab !== tab;
      });
    }
  }

  const init = () => {
    document.querySelectorAll('[data-euroguard-smarter-choice-comparison]').forEach((root) => {
      if (root.dataset.egSmarterChoiceReady === 'true') return;
      root.dataset.egSmarterChoiceReady = 'true';
      new EuroguardSmarterChoiceComparison(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
